import { Button, Form, Modal, message } from "antd";
import { useState } from "react";
import DataTable from "../../../../../components/Tables/DataTable";
import FormModal from "./FormModal";
import {
  useAddCityMutation,
  useDeleteCityMutation,
  useEditCityMutation,
  useGetCitiesQuery,
} from "../../../../../redux/Service/cityApi";
import { useGetCountriesQuery } from "../../../../../redux/Service/countriesApi";

function Cities() {
  const [form] = Form.useForm();
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [isEditing, setIsEditing] = useState<boolean>(false);

  const { data: citiesData, isLoading: isCitiesLoading } =
    useGetCitiesQuery(undefined);

  const cities = citiesData?.ResponseObject ?? [];

  const [deleteCity, { isLoading: isDeleting }] = useDeleteCityMutation();
  const [addCity, { isLoading: isAdding }] = useAddCityMutation();
  const [updateCity, { isLoading: isUpdating }] = useEditCityMutation();

  const {
    data: countriesData,
    isLoading: isCountriesLoading,
    isError: isCountriesError,
  } = useGetCountriesQuery(undefined);

  const countries = countriesData?.ResponseObject ?? [];

  const handleDeletClick = (record: any) => {
    Modal.confirm({
      title: "تأكيد الحذف",
      content: `هل أنت متأكد أنك تريد حذف المدينة "${record.CityName}"؟`,
      okText: "حذف",
      okType: "danger",
      cancelText: "إلغاء",
      onOk: async () => {
        try {
          const response = await deleteCity(record.CityID).unwrap();
          if (response?.ResponseObject === true) {
            message.success("تم حذف المدينة بنجاح");
          } else {
            message.error("حدث خطأ أثناء الحذف");
          }
        } catch (error) {
          message.error("فشل الاتصال بالخادم");
        }
      },
    });
  };

  const columns: any = [
    {
      title: "كود المدينة",
      dataIndex: "CityID",
      key: "CityID",
    },
    {
      title: "اسم المدينة",
      dataIndex: "CityName",
      key: "CityName",
    },
    {
      title: "اسم الدولة",
      dataIndex: "CountryName",
      key: "CountryName",
    },
  ];

  const handleOk = async (values: any) => {
    // For adding a new city, only send CityName and CountryID.
    const body = {
      CityName: values.CityName,
      CountryID: values.CountryID,
      ...(isEditing && { CityID: values.CityID }),
    };

    try {
      let response;
      if (isEditing) {
        response = await updateCity(body).unwrap();
      } else {
        response = await addCity(body).unwrap();
      }
      if (response?.ResponseObject === true) {
        message.success(
          isEditing ? "تم تعديل المدينة بنجاح" : "تمت إضافة المدينة بنجاح"
        );
        setIsModalOpen(false);
        resetModal();
      } else {
        message.error("حدث خطأ أثناء العملية");
      }
    } catch (error) {
      message.error("فشل الاتصال بالخادم");
    }
  };

  function resetModal() {
    form.resetFields();
    setIsEditing(false);
  }

  const handleCancel = () => {
    setIsModalOpen(false);
    resetModal();
  };

  const handleEditClick = (record: any) => {
    setIsEditing(true);
    setIsModalOpen(true);
    const recordData = { ...record };
    // If any date fields are needed, convert with dayjs here.
    setTimeout(() => {
      form.setFieldsValue(recordData);
    }, 0);
  };

  return (
    <>
      <div className="flex flex-wrap gap-4 relative">
        <div className="grid justify-start my-2">
          <Button
            type="primary"
            style={{ width: "10rem" }}
            onClick={() => setIsModalOpen(true)}
          >
            إضافه
          </Button>
        </div>

        <FormModal
          form={form}
          isEditing={isEditing}
          isModalOpen={isModalOpen}
          handleOk={handleOk}
          handleCancel={handleCancel}
          loading={isUpdating || isAdding}
          countries={countries}
        />

        <DataTable
          columns={columns}
          data={cities}
          handleEditClick={handleEditClick}
          handleDeletClick={handleDeletClick}
          isLoading={isCitiesLoading || isDeleting}
        />
      </div>
    </>
  );
}

export default Cities;
